import {
  CardTypes,
  PaymentFrequency,
  CoverType,
  PaymentMethod,
  PolicyHolder,
  StepDirection,
  YesNoAnswer,
} from 'scenes/common/types';
import {
  HomeFormAnswer,
  HomeApiResponses,
  CoverTypeQueryParam,
  SpecifiedContent,
  KickOutChoice,
  HomeStepType,
  HomeMoveFlowAction,
  HomeMoveFlows,
} from 'scenes/home/types';

export const apiResponse = (
  apiResponses: Partial<HomeApiResponses>
): HomeFormAnswer => ({
  direction: StepDirection.ApiResponse,
  formValues: {},
  apiResponses,
});

export const setCoverType = (coverType: CoverType): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { coverType },
  apiResponses: {},
});

export const mapCoverType = (queryParam: string): CoverType | undefined => {
  switch (queryParam) {
    case CoverTypeQueryParam.Contents:
      return CoverType.Contents;
    case CoverTypeQueryParam.Home:
      return CoverType.Building;
    case CoverTypeQueryParam.HomenCon:
      return CoverType.BuildingAndContents;
    default:
      return undefined;
  }
};

export const setOptionalExtras = (
  selectedExtras: string[]
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { selectedExtras },
  apiResponses: {},
});

export const setSpecifiedContents = (
  specifiedContents: SpecifiedContent[]
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { specifiedContents },
  apiResponses: {},
});

export const setUnspecifiedPortableContents = (
  unspecifiedPortableContents: YesNoAnswer,
  unspecifiedPortableContentsLimit: string = ''
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: {
    unspecifiedPortableContents,
    unspecifiedPortableContentsLimit,
  },
  apiResponses: {},
});

export const setIsPortableContentsExtraSelected = (
  isPortableContentsExtraSelected: boolean
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: {
    isPortableContentsExtraSelected,
  },
  apiResponses: {},
});

export const setSpecifiedContentsAnswer = (
  specifiedContentsAnswer: YesNoAnswer
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: {
    specifiedContentsAnswer,
  },
  apiResponses: {},
});

export const setAdditionalPolicyHolders = (
  additionalPolicyHolders: PolicyHolder[]
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { additionalPolicyHolders },
  apiResponses: {},
});

export const setPromoCode = (promoCode: string): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { promoCode },
  apiResponses: {},
});

export const setKickOutChoice = (
  kickOutChoice: KickOutChoice
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { kickOutChoice },
  apiResponses: {},
});

export const setPaymentDate = (paymentDate: string): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { paymentDate },
  apiResponses: {},
});

export const setPaymentMethod = (
  paymentMethod: PaymentMethod
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { paymentMethod },
  apiResponses: {},
});

export const setCardType = (paymentCardType: CardTypes): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { paymentCardType },
  apiResponses: {},
});

export const setPrefilledCampaignId = (
  prefilledCampaignId: string
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { prefilledCampaignId },
  apiResponses: {},
});

export const setPrefilledPromoCode = (
  prefilledPromoCode: string
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { prefilledPromoCode, promoCode: prefilledPromoCode },
  apiResponses: {},
});

export const setColesCampaignCode = (
  colesCampaignCode: string
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { colesCampaignCode },
  apiResponses: {},
});

export const editQuoteDetails = (
  targetStep: HomeStepType
): HomeMoveFlowAction => ({
  direction: StepDirection.MoveFlow,
  formValues: {},
  apiResponses: {},
  targetFlow: HomeMoveFlows.EditQuoteDetails,
  targetStep,
});

export const editPolicyDetails = (
  targetStep: HomeStepType
): HomeMoveFlowAction => ({
  direction: StepDirection.MoveFlow,
  formValues: {},
  apiResponses: {},
  targetFlow: HomeMoveFlows.EditPolicyDetails,
  targetStep,
});

export const editCoverDetails = (
  targetStep: HomeStepType
): HomeMoveFlowAction => ({
  direction: StepDirection.MoveFlow,
  formValues: {},
  apiResponses: {},
  targetFlow: HomeMoveFlows.EditCoverDetails,
  targetStep,
});

export const setPolicyStartDate = (
  policyStartDate: string
): HomeMoveFlowAction => ({
  direction: StepDirection.StayHere,
  formValues: { policyStartDate },
  apiResponses: {},
});

export const setPreselectedPaymentFrequency = (
  preselectedPaymentFrequency: PaymentFrequency
): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { preselectedPaymentFrequency },
  apiResponses: {},
});

export const setHasFlybuys = (hasFlybuys: string): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: {
    hasFlybuys: hasFlybuys === 'Yes' ? YesNoAnswer.Yes : YesNoAnswer.No,
  },
  apiResponses: {},
});

export const resetPropertyBuiltYear = (): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: {
    propertyBuiltYear: '',
  },
  apiResponses: {},
});

export const setFlybuysNumber = (flybuysNumber: string): HomeFormAnswer => ({
  direction: StepDirection.StayHere,
  formValues: { flybuysNumber, hasFlybuys: YesNoAnswer.Yes },
  apiResponses: {},
});
